import { render, staticRenderFns } from "./broadcast.vue?vue&type=template&id=1b893ce4&scoped=true&"
var script = {}
import style0 from "./broadcast.vue?vue&type=style&index=0&id=1b893ce4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b893ce4",
  null
  
)

export default component.exports